import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { useCallback } from 'react';
import { MIN_HERO_SECTION_HEIGHT } from '../constants/dimensions';
import { useVideoTracking } from '../hooks/useVideoTracking';
import { InformationSection } from './InformationSection';
import { MediaSection } from './MediaSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function HeroSection({
  buttonText,
  buttonUrl,
  heroPosition,
  imageUrl,
  isActive = false,
  listingId,
  onClick,
  resultType,
  secondaryButtonText,
  secondaryButtonUrl,
  slug,
  subtitle,
  title,
  videoId,
  openCopilot = false
}) {
  const hasMedia = Boolean(imageUrl || videoId);
  const {
    isMobile
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      md: false
    }
  });
  const {
    trackInteraction
  } = useVideoTracking({
    heroPosition,
    isActive,
    listingId,
    resultType,
    slug,
    videoId
  });
  const handleHeroButtonClick = useCallback(() => {
    trackInteraction('hero button clicked');
    onClick === null || onClick === void 0 || onClick();
  }, [trackInteraction, onClick]);
  const isSolutionsPartnerHero = Boolean(secondaryButtonText && secondaryButtonUrl);
  const mobileButtonSize = isMobile && isSolutionsPartnerHero ? 'small' : undefined;
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    "data-test-id": "hero-section",
    minBlockSize: MIN_HERO_SECTION_HEIGHT,
    paddingBlockEnd: isSolutionsPartnerHero ? '800' : undefined,
    children: isMobile ? /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(InformationSection, {
        buttonText: buttonText,
        buttonUrl: buttonUrl,
        isMobile: isMobile,
        isSolutionsPartnerHero: isSolutionsPartnerHero,
        mobileButtonSize: mobileButtonSize,
        onButtonClick: handleHeroButtonClick,
        openCopilot: openCopilot,
        secondaryButtonText: secondaryButtonText,
        secondaryButtonUrl: secondaryButtonUrl,
        subtitle: subtitle,
        title: title
      }), hasMedia && /*#__PURE__*/_jsx(MediaSection, {
        imageUrl: imageUrl,
        isMobile: isMobile,
        title: title,
        videoId: videoId
      })]
    }) : /*#__PURE__*/_jsxs(Grid, {
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: hasMedia ? 6 : 12,
        children: /*#__PURE__*/_jsx(InformationSection, {
          buttonText: buttonText,
          buttonUrl: buttonUrl,
          isMobile: isMobile,
          isSolutionsPartnerHero: isSolutionsPartnerHero,
          mobileButtonSize: mobileButtonSize,
          onButtonClick: handleHeroButtonClick,
          openCopilot: openCopilot,
          secondaryButtonText: secondaryButtonText,
          secondaryButtonUrl: secondaryButtonUrl,
          subtitle: subtitle,
          title: title
        })
      }), hasMedia && /*#__PURE__*/_jsx(GridItem, {
        size: 6,
        children: /*#__PURE__*/_jsx(MediaSection, {
          imageUrl: imageUrl,
          isMobile: isMobile,
          title: title,
          videoId: videoId
        })
      })]
    })
  });
}